import React from 'react'
import { LuChevronDown, LuChevronUp } from 'react-icons/lu'

import { StyledMenuButton } from './styles'

type Props = {
  isOpen: boolean
  onClickHandler: () => void
}

export const MenuButton: React.FC<Props> = ({ isOpen, onClickHandler }) => {
  return (
    <StyledMenuButton isOpen={isOpen} onClick={onClickHandler} data-ismenubutton="true">
      {isOpen ? <LuChevronUp size={24} /> : <LuChevronDown size={24} />}
    </StyledMenuButton>
  )
}
